import { isNil } from 'lodash';
import { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { MBCardChatThread } from '@shared/scenes/chat/thread/containers/thread/card';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useNavigationFocus } from '@shared/util/navigation';
import { CardChannelContext } from '../contexts/channel';

interface Props {
  threadId: string;
}

export function MBChatThreadBlock({ threadId }: Props) {
  const colors = useContext(ColorThemeContext);
  const channel = useContext(CardChannelContext);
  const channelSlug = channel?.slug;
  const isFocused = useNavigationFocus();
  return (
    <MBView style={styles.container}>
      <MBView style={styles.header}>
        <Text size="overline" weight="semibold" color={colors.input.label}>
          {i18n('card.blocks.chatThread.title').toUpperCase()}
        </Text>
      </MBView>
      {!isNil(channelSlug) && (
        <MBCardChatThread threadId={threadId} isFocused={isFocused} channelSlug={channelSlug} />
      )}
    </MBView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: grid(1),
  },
  header: {
    marginHorizontal: grid(2),
    borderBottomWidth: 1,
    borderBottomColor: Colors.v2.gray10,
    paddingTop: grid(3),
    paddingBottom: grid(1),
  },
});
